import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  Image,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
  Overlay,
} from "react-bootstrap";
import { getStyles } from "./StoreView.style";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Section from "../../Components/Section/Section";
import { FaArrowRight, FaRegClock, FaSearch, FaStar } from "react-icons/fa";
import storeImage from "../../assets/images/default-shop.png";
import { Rating } from "react-simple-star-rating";
import SubcategoryWiseProduct from "../../Components/SubcategoryWiseProduct/SubcategoryWiseProduct";
import MainCategory from "../../Components/MainCategories/MainCategories";
import StoreSubcategoryWiseProduct from "../../Components/StoreSubcategoryWiseProduct/StoreSubcategoryWiseProduct";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";
import FormControl from "react-bootstrap/esm/FormControl";
import { SET_STORE_VIEW_SEARCH } from "../../Redux/Search";
import { useTranslation } from "react-i18next";
import { base_url } from "../../Api/ApiConst";
import {
  SET_SELECTED_PRODUCT,
  SET_SELECTED_SUBCATEGORY_ID,
} from "../../Redux/productId";
import {
  Search_Store_Product,
  Search_Store_Product_Suggestions,
  Selected_Store_Rating,
  User_Last_Viewed,
} from "../../Api";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { parseInt } from "lodash";
import defaultAvtaar from "../../assets/images/User.png";
import { toast } from "react-toastify";
import NoDataFound from "../../Components/NoDataFound/NoDataFound";
import Popover from "react-bootstrap/esm/Popover";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import debounce from "lodash.debounce";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const StoreView: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = React.useState<any>(false);
  const [reviews, setReviews] = React.useState<any>([]);
  const [suggestions, setSuggestions] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [isSearch, setIsSearch] = React.useState<any>("true");
  const [userToken, setUserToken] = React.useState<any>("");

  // Carousel images - you can replace these with actual store images or promotional banners
  const [carouselImages, setCarouselImages] = useState([
    // storeImage, // Default store image as fallback
    // Add more images here or fetch them from API
    "https://plus.unsplash.com/premium_photo-1683865776032-07bf70b0add1?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1682114964475-89d82ea5eae4?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://plus.unsplash.com/premium_photo-1683865776032-07bf70b0add1?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  ]);

  const styles = getStyles(isMobile);
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state;

  const searchTerm: any = useSelector(
    (state: RootState) => state.Search.StoreViewSearch
  );

  const SelectedSubcategory: any = useSelector(
    (state: RootState) => state.productId.selectedSubcategory_id
  );

  const [searchText, setSearchText] = useState<any>("");
  const mainName = useSelector(
    (state: RootState) => state.mainCategory.selectedMainCategory
  );
  const languageId: any = useSelector((state: RootState) => state.lan);

  const dispatch = useDispatch();

  // Carousel configuration
  const carouselResponsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  // Additional styles for the background carousel
  const carouselContainerStyle = {
    position: "absolute" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
  };

  const carouselImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
    // filter: 'blur(2px) brightness(0.3)', // Blur and darken for better text readability
  };

  const overlayStyle = {
    position: "absolute" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(135deg, rgb(255,255,255, 0.5) 0%, rgba(255,255,255,0.5) 100%)",
    zIndex: 2,
  };

  const contentStyle = {
    position: "relative" as const,
    zIndex: 3,
  };

  const enhancedSectionStyle = {
    ...styles.bg,
    position: "relative" as const,
    minHeight: "300px",
    overflow: "hidden",
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(SET_SELECTED_SUBCATEGORY_ID(""));
  }, []);

  useEffect(() => {
    debouncedHandleSearch(searchText);
  }, [searchText]);

  useEffect(() => {
    setSearchText(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    if (state === null || state === undefined) {
      navigate("/", { replace: true });
    }
    return;
  }, [state, navigate]);

  // You might want to fetch store-specific carousel images
  useEffect(() => {
    // Example: Fetch carousel images for the store
    // fetchStoreCarouselImages();
  }, []);

  const breadcrumbs = [
    <Link to="/" key="home">
      {t("footer.home")}
    </Link>,
    mainName?.language_data?.length === 0
      ? mainName?.name
      : languageId === "ne"
        ? mainName?.language_data[0]?.name
        : mainName?.name,
  ];

  const handleSearch = (name: any) => {
    dispatch(SET_STORE_VIEW_SEARCH(name ? name : searchText));
  };

  const StoreRating = async () => {
    try {
      const response = await Selected_Store_Rating(storeId);
      if (response && response.status === 200) {
        // console.log(response.data, "buyyyy---------->");
        if (response.data.status === true) {
          setReviews(response.data.store_rating_list);
        } else {
          setReviews([]);
        }
      } else {
        console.log("Error fetching Past orders");
        toast.error(response?.data?.error);
      }
    } catch (error) {
      console.log("Error fetching Past orders", error);
    }
  };

  const debouncedHandleSearch = debounce(async (searchText: any) => {
    if (searchText) {
      try {
        const response = await Search_Store_Product_Suggestions(
          searchText,
          storeId,
          isSearch
        );
        if (response && response.status === 200) {
          const formattedStores = response.data.product_list.map(
            (product: any) => ({
              id: product?.id,
              img: product?.product_image,
              name: product?.product_name,
            })
          );
          setSuggestions(formattedStores);
          dispatch(
            SET_SELECTED_SUBCATEGORY_ID(
              response?.data?.search_product_list[0]?.product_subcategory
            )
          );
        } else {
          console.log("Error fetching Store Product Details");
        }
      } catch (error) {
        console.log("Error fetching Store Product Details", error);
      }
    }
  }, 500);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch("");
    }
  };

  const fetchReviews = () => {
    setShowModal(true);
  };

  if (!state) {
    return null;
  }

  const {
    store_name,
    store_type,
    distance_in_km,
    language_data,
    store_logo,
    store_rating,
    storeId,
  } = state;

  return (
    <div className="store">
      <Section className="storeView" style={enhancedSectionStyle}>
        {/* Background Carousel */}
        <div style={carouselContainerStyle}>
          <Carousel
            responsive={carouselResponsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={4000}
            showDots={false}
            // showArrows={false}
            customTransition="transform 1000ms ease-in-out"
            transitionDuration={1000}
          >
            {carouselImages.map((image, index) => (
              <div key={index}>
                <img
                  src={image}
                  alt={`Store background ${index + 1}`}
                  style={carouselImageStyle}
                />
              </div>
            ))}
          </Carousel>
        </div>

        {/* Overlay for better text readability */}
        {/* <div style={overlayStyle}></div> */}

        {/* Content */}
        <Container style={contentStyle}>
          {/* Enhanced Breadcrumbs */}
          <Row>
            <Col>
              <div
                className="breadcrumbs"
                style={{
                  // background: "rgba(255, 255, 255, 0.1)",
                  // backdropFilter: "blur(15px)",
                  borderRadius: "25px",
                  padding: "12px 20px",
                  marginBottom: "20px",
                  // border: "1px solid rgba(255, 255, 255, 0.2)",
                  display: "inline-flex",
                  alignItems: "center",
                  // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                }}
              >
                {breadcrumbs.map((crumb, index) => (
                  <React.Fragment key={index}>
                    <span
                      style={{
                        // color:
                        //   index === 0 ? "#fff" : "rgba(255, 255, 255, 0.8)",
                        // fontFamily: "var(--primary-font-medium)",
                        // fontSize: 14,
                        // fontWeight: index === 0 ? 600 : 400,
                        // transition: "all 0.3s ease",
                        // cursor: index === 0 ? "pointer" : "default",
                      }}
                    >
                      {crumb}
                    </span>
                    {index !== breadcrumbs.length - 1 && (
                      <FaArrowRight
                        className="mx-3"
                        style={{
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "12px",
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </Col>
          </Row>

          {/* Enhanced Store Info Section */}
          <Row>
            <Col sm={12} style={{ paddingBottom: 0 }}>
              <div
                style={{
                  ...styles.storeWrap,
                  // background: "rgba(255, 255, 255, 1)",
                  // backdropFilter: "blur(20px)",
                  // borderRadius: "20px",
                  // padding: "30px",
                  // border: "1px solid rgba(255, 255, 255, 1)",
                  // boxShadow: "0 25px 50px rgba(0, 0, 0, 0.15)",
                  // position: "relative",
                  // overflow: "hidden",
                }}
              >
                {/* Subtle animated background pattern */}
                {/* <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    // background:
                    //   "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                    zIndex: 1,
                  }}
                /> */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                    pointerEvents: "none",
                  }}
                />

                <div
                  style={{
                    ...styles.storeHeader,
                    // position: "relative",
                    // zIndex: 2,
                    // display: "flex",
                    // alignItems: "center",
                    // gap: "25px",
                    // flexWrap: "wrap",
                  }}
                >
                  {/* Enhanced Store Image */}
                  <div
                    style={{
                      ...styles.storeImageWrap,
                      // position: "relative",
                    }}
                  >
                    <div
                      style={{
                        // background:
                        //   "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)",
                        // borderRadius: "50%",
                        padding: "5px",
                        display: "inline-block",
                      }}
                    >
                      <Image
                        src={
                          store_logo ? `${base_url}/${store_logo}` : storeImage
                        }
                        style={{
                          ...styles.storeImage,
                          // border: "3px solid rgba(255, 255, 255, 0.3)",
                          // borderRadius: "50%",
                          // boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
                          // transition: "all 0.3s ease",
                          // cursor: "pointer",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      />
                    </div>

                  </div>
                  <div
                    style={{
                      ...styles.storeNameWrap,
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: "20px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ marginBottom: "15px" }}>
                        <h2
                          style={{
                            ...styles.storeName,
                            // color: "#fff",
                            // textShadow: "2px 4px 8px rgba(0, 0, 0, 0.3)",
                            // fontSize: isMobile ? "24px" : "32px",
                            // fontWeight: 700,
                            // marginBottom: "8px",
                            // letterSpacing: "0.5px",
                          }}
                        >
                          {language_data === undefined
                            ? store_name
                            : languageId === "ne"
                              ? language_data
                              : store_name}
                        </h2>
                      </div>

                      {/* Enhanced Rating Section */}
                      {store_rating !== undefined && (
                        <div
                          style={styles.ratingWrap
                          }
                          onClick={fetchReviews}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                            e.currentTarget.style.boxShadow =
                              "0 12px 35px rgba(0, 0, 0, 0.15)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                              "0 8px 25px rgba(0, 0, 0, 0.1)";
                          }}
                        >
                          <Rating
                            initialValue={store_rating}
                            allowHover={false}
                            readonly={true}
                            size={20}
                          />
                          <p
                            style={{
                              fontSize: 18,
                              fontFamily: "var(--primary-font-semibold)",
                              color: "#fff",
                              textShadow: "1px 2px 4px rgba(0, 0, 0, 0.3)",
                              margin: 0,
                            }}
                          >
                            {Math.round(store_rating * 10) / 10}
                          </p>
                          <span
                            style={{
                              fontSize: 12,
                              color: "rgba(255, 255, 255, 0.8)",
                              fontWeight: 500,
                            }}
                          >
                            Reviews
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Compact Search Bar */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "rgba(255, 255, 255, 0.9)",
                        borderRadius: "20px",
                        padding: "5px",
                        boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
                        border: "1px solid rgba(255, 255, 255, 0.3)",
                        minWidth: isMobile ? "200px" : "250px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <ReactSearchAutocomplete
                          className="compact-search-input"
                          items={suggestions}
                          onSearch={(input: string) => setSearchText(input)}
                          onSelect={(item: any) => handleSearch(item?.name)}
                          formatResult={(item: any) => (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "6px 0",
                              }}
                            >
                              {item?.img && (
                                <div
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <img
                                    src={`${base_url}${item?.img}`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                    alt={item?.name}
                                  />
                                </div>
                              )}
                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  color: "#333",
                                }}
                              >
                                {item?.name}
                              </span>
                            </div>
                          )}
                          autoFocus={true}
                          styling={{
                            borderRadius: "15px",
                            border: "none",
                            boxShadow: "none",
                            fontSize: "14px",
                            fontFamily: "var(--primary-font-medium)",
                            height: "35px",
                          }}
                          placeholder="Search products..."
                        />
                      </div>

                      <Button
                        variant="primary"
                        className="compact-search-btn"
                        onClick={() => handleSearch("")}
                        style={{
                          background:
                            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          border: "none",
                          borderRadius: "15px",
                          padding: "8px 12px",
                          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)",
                          transition: "all 0.3s ease",
                          fontWeight: 600,
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "35px",
                          height: "35px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 20px rgba(102, 126, 234, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 15px rgba(102, 126, 234, 0.3)";
                        }}
                      >
                        <FaSearch style={{ fontSize: "12px" }} />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>

      <StoreSubcategoryWiseProduct />

      <Modal
        centered
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        className="ratingModal storeRatingModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("userProfile.storeReviews")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reviews && reviews.length === 0 ? (
            <NoDataFound title={t("commonHeader.noReviews")} />
          ) : (
            reviews.length > 0 &&
            reviews &&
            reviews.map((review: any) => (
              <div key={review.id} className="mb-3 store-rating-wrap">
                <div className="d-flex align-items-start">
                  <Image
                    src={review.user_image ? review.user_image : defaultAvtaar}
                    roundedCircle
                    width={50}
                    height={50}
                    style={{ marginRight: 10 }}
                  />
                  <div>
                    <h5 className="mb-0">
                      {review.customer_name
                        ? review.customer_name
                        : "Anonymous User"}
                    </h5>
                    <Rating
                      initialValue={review.rate}
                      allowHover={false}
                      readonly={true}
                      size={22}
                      style={{ marginBottom: "0.5rem" }}
                    />
                    <p className="mb-0">{review.client_comment}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t("commonHeader.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StoreView;
